module.exports = __webpack_public_path__ + "media/images/left-adf33978.svg";